<template>
  <div class="all">
    <div class="banner" @click="toMain">
      <img src="../../../assets/logo.png" />六六书签
    </div>
    <div class="outbox" v-if="show">
      <div class="shareTitle">
        {{ shareInfo.shareUserName }}分享给您了一个链接：
      </div>
      <div class="item">
        <div class="label">书签名称：</div>
        <div class="content">
          {{ shareInfo.name }}
        </div>
      </div>
      <div class="item">
        <div class="label">书签地址：</div>
        <div class="content">
          <a :href="shareInfo.url" target="_blank">{{ shareInfo.url }}</a>
        </div>
      </div>
      <div class="item" v-if="shareInfo.account">
        <div class="label">书签账号：</div>
        <div class="content">
          {{ shareInfo.account }}
        </div>
      </div>
      <div class="item" v-if="shareInfo.password">
        <div class="label">书签密码：</div>
        <div class="content">
          {{ shareInfo.password }}
        </div>
      </div>
      <div class="save">
        <a-button type="primary" @click="openSaveAs"
          >存到我的书签</a-button
        >
      </div>
    </div>

    <div class="pop-area">
      <SelectCategory ref="categoryChild" :onSelect="saveAs" />
      <div id="pwdInput">
        <a-modal
          :visible="pwdShow"
          title="请输入密码"
          @ok="openWithPwd"
          okText="确认"
          cancelText="关闭"
        >
          <a-input-password
            placeholder="输入此密码才能查看链接"
            v-model="pwd"
          />
        </a-modal>
      </div>
    </div>
  </div>
</template>
<script>
import addButton from "../../../components/bookmark/addButton.vue";
import SelectCategory from "../../../components/category/selectCategory";
export default {
  components: { addButton, SelectCategory },
  data() {
    return {
      show:false,
      shareInfo: {},
      pwdShow: false,
      pwd: "",
    };
  },
  methods: {
    openWithPwd() {
      this.$req.post(
        "/api/share/open/pwd/share",
        {
          id: this.$route.params.id,
          pwd: this.pwd,
        },
        (res) => {
          this.shareInfo = res.data;
          this.show = true;
          this.pwdShow = false;
        }
      );
    },
    toMain() {
      this.$router.push("/");
    },
    openSaveAs(){
       this.$refs.categoryChild.visible = true;
    },
    saveAs(val) {
      this.$req.post(
      "/api/share/save/tome",
      {
        categoryId:val,
        shareId:this.$route.params.id,
      },
      (res) => {
       this.$message.success("保存成功！");
      }
    );
    },
  },
  created() {
    this.$req.get(
      "/api/share/open/share/" + this.$route.params.id,
      {},
      (res) => {
        let data = res.data;
        if (data.needPwd) {
          this.pwdShow = true;
          return;
        } else {
          this.shareInfo = data;
          this.show = true;
        }
      }
    );
  },
};
</script>

<style scoped>
.all {
  padding-top: 15%;
  height: 100%;
  background: #f8fafb;
}
.outbox {
  margin: auto;
  padding-bottom: 20px;
  width: 400px;
  background-color: #ffffff;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
  cursor: pointer;
  border-radius: 8px;
}

.item {
  display: flex;
  justify-content: left;
  margin-left: 10px;
  margin-top: 10px;
}
.label {
  margin-right: 10px;
}
.content {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 60%;
}
.shareTitle {
  text-align: left;
  background-color: #19a0fb;
  color: #ffffff;
  font-size: 16px;
  padding-left: 10px;
  height: 30px;
  line-height: 30px;
}
.banner {
  text-align: center;
  margin-bottom: 40px;
  height: 30px;
  font-size: 20px;
}
.banner img {
  height: 100%;
  margin-right: 6px;
}
.save {
  margin-top: 15px;
  text-align: center;
}
</style>